export default __webpack_public_path__ + "static/media/Bedroom vessels_V.3.327cc975.png";